module.exports = __webpack_public_path__ + "media/app/assets/races/blood_elf_male-f90a96771e5011cd152f41baebd1fe5d.png";